import React from "react";
import { Container, Typography, Box, Divider } from "@mui/material";

const researchAreas = [
  {
    title: "Next-Generation Solar",
    body: "Researching new materials like Perovskites to make solar panels more efficient and affordable than ever before.",
  },
  {
    title: "Better Batteries",
    body: "Developing Solid-State and Long-Duration storage so that renewable energy is available 24/7, even when the sun is not shining.",
  },
  {
    title: "Green Hydrogen",
    body: "Finding cheaper, cleaner ways to produce hydrogen for heavy industry and long-distance transport.",
  },
  {
    title: "Smart Grids",
    body: "Building AI-driven systems that automatically balance energy supply and demand, reducing waste across the entire power grid.",
  },
];

const RenewableEnergy: React.FC = () => {
  return (
    <Container maxWidth="md" style={{ marginTop: "50px", marginBottom: "80px", fontFamily: "Roboto, sans-serif", padding: "20px" }}>
      <Typography variant="h4" style={{ fontWeight: "bold", marginBottom: "8px" }}>
        Renewable Energy
      </Typography>
      <Typography variant="body1" style={{ color: "#555", marginBottom: "40px", lineHeight: 1.8 }}>
        Our mission is to discover and develop the energy sources of tomorrow. We combine advanced science with practical
        engineering to create a cleaner, more sustainable world — through feasibility studies and integration of solar,
        wind, and microgrid solutions.
      </Typography>

      <Divider style={{ marginBottom: "40px" }} />

      <Typography variant="h5" style={{ fontWeight: "bold", marginBottom: "24px" }}>
        What We're Working On
      </Typography>

      {researchAreas.map((item, i) => (
        <Box key={i} style={{ marginBottom: "28px" }}>
          <Typography variant="h6" style={{ fontWeight: "bold", marginBottom: "8px" }}>
            {item.title}
          </Typography>
          <Typography variant="body1" style={{ color: "#555", lineHeight: 1.8 }}>
            {item.body}
          </Typography>
        </Box>
      ))}

      <Divider style={{ margin: "40px 0" }} />

      <Typography variant="h5" style={{ fontWeight: "bold", marginBottom: "16px" }}>
        Our Approach
      </Typography>
      <Typography variant="body1" style={{ color: "#555", lineHeight: 1.8 }}>
        We use <strong>AI-powered simulations</strong> to speed up the discovery of new materials. By testing ideas in a
        digital environment first, we move from theory to real-world solution in record time — with the goal of making
        renewable energy the most reliable and affordable choice for everyone, everywhere.
      </Typography>
    </Container>
  );
};

export default RenewableEnergy;
